module.exports = __webpack_public_path__ + "img/bank_def.60f6c791.png";